import { nombrePropio } from "../common"

/*
	Nombres recortados para listas y tarjetas.

	En WAPP la gente viene con dos nombres y dos apellidos, asi que en una tarjeta
	de telefono "Jose Sindulfo Guillen Romero" ocupa dos renglones y empuja todo
	lo demas. Esteban pidio (2026-09-16) que el profesor salga con primer nombre y
	primer apellido, y el alumno con primer nombre y sus dos apellidos: al alumno
	hay que poder identificarlo sin ambiguedad, al profesor del horario no.

	Se recorta solo para mostrar. El dato completo no se toca.
*/

const partes = (valor : string | null | undefined) : string[] =>
	String(valor || "").trim().split(/\s+/).filter(Boolean)

/**
	Personal: el nombre que eligio para WAPP (users.nombre_mostrar, menu de su foto, 2026-10-29). Sin eleccion o si el
	back no lo manda, primer nombre y primer apellido: "Jose Guillen".
*/
export const nombreDeProfesor = (nombres : string | null | undefined, apellidos : string | null | undefined, mostrar? : string | null) : string =>
{
	if(mostrar && mostrar.trim())
	{
		return mostrar.trim()
	}
	const n = partes(nombres)[0] || ""
	const a = partes(apellidos)[0] || ""

	return nombrePropio([n, a].filter(Boolean).join(" "))
}

/** Primer nombre y los dos apellidos: "Liany Perez Toledo". */
export const nombreDeAlumno = (nombres : string | null | undefined, apellidos : string | null | undefined) : string =>
{
	const n = partes(nombres)[0] || ""
	const a = partes(apellidos).slice(0, 2)

	return nombrePropio([n, ...a].filter(Boolean).join(" "))
}

/** Lo mismo que nombreDeProfesor, desde la fila de users: {nombre_mostrar, first_name, last_name}. */
export const nombrePersonal = (u : {nombre_mostrar? : string | null, first_name? : string | null, last_name? : string | null} | null | undefined) : string =>
	u ? nombreDeProfesor(u.first_name, u.last_name, u.nombre_mostrar) : ""

/** Para saludar ("Hola Samara"): el nombre elegido sin el apellido; sin eleccion, sus nombres tal cual. */
export const nombreDePila = (u : {nombre_mostrar? : string | null, first_name? : string | null, last_name? : string | null} | null | undefined) : string =>
{
	if(!u)
	{
		return ""
	}
	if(!u.nombre_mostrar)
	{
		return String(u.first_name || "").trim()
	}
	const apellidos = new Set(partes(u.last_name).map((w) => w.toLowerCase()))
	const palabras  = partes(u.nombre_mostrar)
	while(palabras.length > 1 && apellidos.has(palabras[palabras.length - 1].toLowerCase()))
	{
		palabras.pop()
	}
	return palabras.join(" ")
}

export default nombreDeAlumno
